import React from "react";
import { Card, Col, Progress, Rate, Space, Tag, Typography } from "antd";
import { transformSingleResponseData } from "../../../../utils/surveys";

const QuestionResponsesRating = ({ question }) => {
    const ratingsArr = () => {
        const array = [];
        for (let i = 1; i <= question?.range; i++) {
            array.push(i);
        }
        return array;
    };

    return (
        <Col span={24}>
            <Card
                bordered={true}
                style={{
                    background: "#fafafa",
                    textAlign: "left",
                }}
            >
                <Typography.Title level={4}>
                    {question.headline}
                </Typography.Title>
                <div
                    style={{
                        marginTop: "20px",
                    }}
                >
                    <Tag color="blue">Rating</Tag>
                    <Tag color="orange">
                        {question.responses.length} responses
                    </Tag>
                </div>
                <Space
                    direction="vertical"
                    size="large"
                    style={{ marginTop: "50px", width: "100%" }}
                >
                    {ratingsArr()?.map((rating) => (
                        <div key={rating}>
                            <Space
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <Space size="large">
                                    <Rate disabled defaultValue={rating} />
                                    <Tag bordered={false}>
                                        {transformSingleResponseData(
                                            question,
                                            rating
                                        ).overallPercentage || 0}{" "}
                                        %
                                    </Tag>
                                </Space>
                                <Tag bordered={false}>
                                    {
                                        transformSingleResponseData(
                                            question,
                                            rating
                                        ).count
                                    }{" "}
                                    {transformSingleResponseData(
                                        question,
                                        rating
                                    ).count === 1
                                        ? "response"
                                        : "responses"}
                                </Tag>
                            </Space>
                            <Progress
                                percent={
                                    transformSingleResponseData(
                                        question,
                                        rating
                                    ).overallPercentage
                                }
                                status="active"
                                size="default"
                                showInfo={false}
                            />
                        </div>
                    ))}
                </Space>
            </Card>
        </Col>
    );
};

export default QuestionResponsesRating;
